import { makeStyles } from "@material-ui/styles";

const eventSettingsStyles = makeStyles(() => ({
	secondaryActionContainer: {
		display: "flex",
		alignItems: "flex-end",
		gap: 5
	}
}));

export default eventSettingsStyles;
